import React from 'react';
const IconMiscPie = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M5 12C5 15.52 7.61 18.43 11 18.92V21.95C5.95 21.45 2 17.19 2 12C2 6.81005 5.95 2.55005 11 2.05005V5.08005C7.61 5.57005 5 8.48005 5 12ZM13 5.08005C16.06 5.52005 18.48 7.94005 18.92 11H21.95C21.48 6.28005 17.72 2.52005 13 2.05005V5.08005ZM18.92 13C18.48 16.06 16.06 18.48 13 18.92V21.95C17.72 21.48 21.48 17.72 21.95 13H18.92Z" fill="#666666"/>
</svg>
);
};
export default IconMiscPie;